import { render } from "./EnquiryLists.vue?vue&type=template&id=5e1edcf9"
import script from "./EnquiryLists.vue?vue&type=script&lang=js"
export * from "./EnquiryLists.vue?vue&type=script&lang=js"

import "./EnquiryLists.vue?vue&type=style&index=0&id=5e1edcf9&lang=scss"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__